// Canonical milestone status values and allowed transitions — single source
// of truth so every screen that edits a milestone's status agrees on what's
// possible. Mirrors the server-side whitelist in src/api/router.js's
// PUT /milestones/:id handler; keep the two in sync.
export const MILESTONE_STATUS_TRANSITIONS = {
  'Awaiting':      ['Awaiting', 'Ready to bill', 'Cancelled'],
  'Ready to bill': ['Ready to bill', 'Awaiting', 'Invoiced', 'Cancelled'],
  'Invoiced':      ['Invoiced', 'Paid', 'Cancelled'],
  'Paid':          ['Paid'],
  // A cancelled milestone can be reinstated to Awaiting if it was cancelled in error.
  'Cancelled':     ['Cancelled', 'Awaiting'],
};
export const ALL_MILESTONE_STATUSES = ['Awaiting', 'Ready to bill', 'Invoiced', 'Paid', 'Cancelled'];

// "Done as far as the PM is concerned" — delivered, and only finance work left. The
// Project Update page collapses these milestones to a compact read-only row, since there
// is no delivery update left to give. Both capitalisations of Ready to bill are here
// because older records carry the other one.
export const MILESTONE_DONE_STATUSES = ['Ready to bill', 'Ready To Bill', 'Invoiced', 'Paid', 'Complete', 'Completed', 'Credit Noted'];
export const isMilestoneDone = (status) => MILESTONE_DONE_STATUSES.includes(status);

const isReadyToBill = (status) => (status || '').toLowerCase() === 'ready to bill';

// Whether a Service Entry Sheet number has to be recorded before this milestone change
// can be saved: the SOW is SES applicable and the milestone is being moved to Ready to
// Bill from somewhere else. Asked by both the input that collects the number and the
// validation that blocks the save, so the two cannot disagree about when it is wanted.
export const sesNumberRequired = ({ sesApplicable, savedStatus, newStatus }) =>
  !!sesApplicable && isReadyToBill(newStatus) && !isReadyToBill(savedStatus);

// Client PO numbers in the 5200 series come from a SAP purchasing system that will not
// accept an invoice without a Service Entry Sheet, whether or not anybody remembered to
// tick SES applicable on the SOW. Either one means an SES number belongs on the invoice,
// so the Record Invoice screen shows it rather than sending finance off to find it.
const SES_PO_PREFIX = '5200';
export const sesExpected = ({ sesApplicable, poNumber } = {}) =>
  !!sesApplicable || String(poNumber ?? '').trim().startsWith(SES_PO_PREFIX);
